define('app/config/categories',{
	'BANK': 'Bank',
	'CREDIT_UNION': 'Credit Union',
	'OTHER': 'Other'
});

